import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class AICopilotConfigService {
  
  static getActiveConfig() {
    return HttpUtil.get(API_ROUTES.AI_COPILOT_CONFIG.GET_ACTIVE_CONFIG);
  }

  static getStyles() {
    return HttpUtil.get(API_ROUTES.AI_COPILOT_CONFIG.GET_STYLES);
  }
 static getStyless() {
    return HttpUtil.get(API_ROUTES.AI_COPILOT_CONFIG.GET_ALL_STYLE);
  }
  static getTones() {
    return HttpUtil.get(API_ROUTES.AI_COPILOT_CONFIG.GET_TONES);
  }
static saveConfig(payload) {
  return HttpUtil.post(
    API_ROUTES.AI_COPILOT_CONFIG.SAVE_CONFIG,
    payload
  );
}

  static savePrompts(payload) {
    return HttpUtil.post(
      API_ROUTES.AI_COPILOT_CONFIG.SAVE_PROMPTS,
      payload
    );
  }

  static listPrompts() {
    return HttpUtil.get(
      API_ROUTES.AI_COPILOT_CONFIG.LIST_PROMPTS
    );
  }

  static getCategoriesTopics() {
    return HttpUtil.get(
      API_ROUTES.AI_COPILOT_CONFIG.GET_CATEGORIES_TOPICS
    );
  }

  static getCategoriesTopicsByFramework(framework) {
    return HttpUtil.get(
      API_ROUTES.AI_COPILOT_CONFIG.GET_CATEGORIES_TOPICS_BY_FRAMEWORK
        .replace('<framework>', framework)
    );
  }

  static getPromptsByCategoryTopic(framework, category, topic) {
    return HttpUtil.get(
      API_ROUTES.AI_COPILOT_CONFIG.GET_PROMPTS_BY_CATEGORY_TOPIC
        .replace('<framework>', framework)
        .replace('<category>', category)
        .replace('<topic>', topic)
    );
  }

  static deletePromptByCategoryTopic(framework, category, topic) {
    return HttpUtil.delete(
      API_ROUTES.AI_COPILOT_CONFIG.DELETE_PROMPT_BY_CATEGORY_TOPIC
        .replace('<framework>', framework)
        .replace('<category>', category)
        .replace('<topic>', topic)
    );
  }

  static generatePrompt(formData) {
    return HttpUtil.post(
      API_ROUTES.AI_COPILOT_CONFIG.GENERATE_PROMPT,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
  }

  static updateWordCount(id, sectionType, countType) {
    return HttpUtil.patch(
      API_ROUTES.AI_COPILOT_CONFIG.UPDATE_WORD_COUNT
      .replace('<id>', id)
      .replace('<sectionType>', sectionType)
      .replace('<countType>', countType), {}
    )
  }

  static updateStyle(id, type) {
    return HttpUtil.patch(
      API_ROUTES.AI_COPILOT_CONFIG.UPDATE_STYLE
      .replace('<id>', id)
      .replace('<type>', type), {}
    )
  }

  static updateTone(id, type) {
    return HttpUtil.patch(
      API_ROUTES.AI_COPILOT_CONFIG.UPDATE_TONE
      .replace('<id>', id)
      .replace('<type>', type), {}
    )
  }

  static applyDeafultConfig(companyId) {
    return HttpUtil.patch(
      API_ROUTES.AI_COPILOT_CONFIG.APPLY_DEFAULT_CONFIG_FOR_COMPANY
      .replace('<companyId>', companyId), {}
    )
  }

    static getCopilotSettings() {
    return HttpUtil.get(API_ROUTES.AI_COPILOT_CONFIG.GET_COPILOT_SET);
  }

  static getCopoliotHistory(companyId, userId, startLimit, endLimit, reportName, reportPage) {
    return HttpUtil.get(API_ROUTES.AI_COPILOT_CONFIG.GET_COPILOT_HISTORY
      .replace('<companyId>', companyId)
      .replace('<userId>', userId)
      .replace('<reportName>', reportName || '')
      .replace('<reportPage>', reportPage || '')
      .replace('<startLimit>', startLimit)
      .replace('<endLimit>', endLimit));
  }

  static deleteCopilotHistory(companyId, userId, reportName, reportPage) {
    return HttpUtil.delete(API_ROUTES.AI_COPILOT_CONFIG.DELETE_COPILOT_HISTORY
      .replace('<companyId>', companyId)
      .replace('<userId>', userId)
      .replace('<reportName>', reportName || '')
      .replace('<reportPage>', reportPage || ''));
  }
}
